export default __webpack_public_path__ + "static/media/zh.168935f4.svg";